<div class="main-container lg-view" [class.form-open]="isFormOpen">
	<h3>Assignees</h3>

	<div class="contacts-list">
		<app-loader *ngIf="isAssigneesListLoading"></app-loader>
		<div class="contact-container" *ngFor="let assignee of assignees" (click)="editAssignee(assignee)">
			<div class="contact-name">
				<span>{{ assignee.lastName }}, {{ assignee.firstName }} </span>
				<span class="title">{{ assignee.title }}</span>
			</div>
			<div class="contact-details">
				<span class="contact-email">{{ assignee.email }}</span>
				<span class="contact-phone">{{ assignee.phone }}</span>
			</div>
		</div>
	</div>

	<div class="contact-form main-form" *ngIf="isFormOpen">
		<match-contacts [filter]="matchAssigneeFilter" [service]="assigneeService"
			(userAlreadyExistsByEmailOrPhone)="toggleSaveButtonLockState($event)"
			(replaceContact)="replaceAssignee($event)" (applyContactToSite)="applyAssigneeToSite($event)"
			(showContact)="showAssignee($event)">
		</match-contacts>
		<form [formGroup]="formModel">
			<div class="contact-form-name">
				<mat-form-field>
					<mat-label>First name</mat-label>
					<input matInput formControlName="firstName" (keyup)="formDataChange$.next($event.target.value)" />
				</mat-form-field>

				<mat-form-field>
					<mat-label>Last name</mat-label>
					<input matInput formControlName="lastName" (keyup)="formDataChange$.next($event.target.value)" />
				</mat-form-field>
			</div>

			<div>
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput formControlName="email" (keyup)="formDataChange$.next($event.target.value)" />
				</mat-form-field>
			</div>

			<div>
				<mat-form-field>
					<mat-label>Phone</mat-label>
					<input matInput formControlName="phone" (keyup)="formDataChange$.next($event.target.value)" />
				</mat-form-field>
			</div>

			<div>
				<mat-form-field>
					<mat-label>Title</mat-label>
					<input matInput formControlName="title" />
				</mat-form-field>
			</div>
		</form>
	</div>
</div>

<div class="actions-container md-view" [class.form-open]="isFormOpen">
	<ng-container
		*ngIf="!customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
		<app-loader *ngIf="isAssigneeActionInProgress"></app-loader>
		<ng-container *ngIf="!isFormOpen">
			<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" [subpage]="'..'" @fadeIn></action-button>
			<action-button [icon]="ButtonIcons.Add" [name]="'Add'" [clickAction]="editAssignee.bind(self)" @fadeIn>
			</action-button>
		</ng-container>

		<ng-container *ngIf="isFormOpen">
			<action-button [icon]="ButtonIcons.Cancel" [name]="'Cancel'" [clickAction]="cancelEditAssignee.bind(self)"
				@fadeIn></action-button>
			<action-button [icon]="ButtonIcons.Save" [name]="'Save'" [clickAction]="saveAssignee.bind(self)"
				[disabled]="!canSave()" @fadeIn></action-button>
			<action-button [icon]="ButtonIcons.Delete" [name]="'Delete'" [clickAction]="deleteAssignee.bind(self)"
				*ngIf="mode === 'edit'" @fadeIn></action-button>
		</ng-container>
	</ng-container>

	<div class="actions-placeholder-message" *ngIf="customerPreferences.preferences.isNotificationDisabled || customerPreferences.preferences.isJobAutoSkipped">
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && !customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.NotificationDisabled }}</span>
		<span
			*ngIf="customerPreferences.preferences.isJobAutoSkipped && !customerPreferences.preferences.isNotificationDisabled">
			{{ ActionsPlaceholderSettings.JobAutoSkipped }}</span>
		<span
			*ngIf="customerPreferences.preferences.isNotificationDisabled && customerPreferences.preferences.isJobAutoSkipped">
			{{ ActionsPlaceholderSettings.BothDisabled }}</span>
	</div>
</div>